// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__MEQp-","main_modal":"Modal_main_modal__7J0Ea"};